import { FunctionalComponent, VNode, h } from '@stencil/core';

export const AdsDropdownDivider: FunctionalComponent = () => (<hr class="c-dropdown__divider" />) as VNode;
